import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiaireRelampingLedPage() {
  const parcours = getTravauxTertiaireStub('relamping-led');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE pour la fiche BAT-EQ-127",
        },
        {
          label: 'Audit OPERAT',
          href: '/tertiaire/decret-tertiaire',
          iconName: 'gauge',
          hint: "Premier geste du plan d'actions",
        },
        {
          label: 'Pilotage du bâtiment GTB (fiche BAT-TH-116)',
          href: '/tertiaire/travaux/gtb',
          iconName: 'cpu',
          hint: 'Pilotage éclairage par GTB en complément',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
